import React, { useState } from 'react';
import { Layout, Row, Col, Form, Input, Button, message } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import * as authService from './authService';

const { Content } = Layout;

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);

  const onFinish = async (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.warning('새 비밀번호가 일치하지 않습니다');
      return;
    }
    setLoading(true);
    try {
      await authService.changePassword(values.oldPassword, values.newPassword);
      message.success('비밀번호가 변경되었습니다');
      window.history.back();
    } catch (err) {
      console.error('Change password error:', err);
      const msg = err.response?.data?.message || err.message || '비밀번호 변경에 실패했습니다';
      message.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout style={{ minHeight: '100vh', padding: '25px' }}>
      <Content>
        <Row>
          <Col span={8} offset={8}>
            <h2 style={{ textAlign: 'center', marginTop: '50px', marginBottom: '30px' }}>
              비밀번호 변경
            </h2>
            <Form name="change_password" onFinish={onFinish}>
              <Form.Item
                name="oldPassword"
                rules={[{ required: true, message: '현재 비밀번호를 입력하세요' }]}
              >
                <Input type="password" prefix={<LockOutlined />} placeholder="현재 비밀번호" />
              </Form.Item>
              <Form.Item
                name="newPassword"
                rules={[
                  { required: true, message: '새 비밀번호를 입력하세요' },
                  { min: 8, message: '비밀번호는 8자 이상이어야 합니다' },
                ]}
              >
                <Input type="password" prefix={<LockOutlined />} placeholder="새 비밀번호 (8자 이상)" />
              </Form.Item>
              <Form.Item
                name="confirmPassword"
                rules={[{ required: true, message: '비밀번호 확인을 입력하세요' }]}
              >
                <Input type="password" prefix={<LockOutlined />} placeholder="새 비밀번호 확인" />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block loading={loading}>
                  비밀번호 변경
                </Button>
              </Form.Item>
            </Form>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};

export default ChangePassword;
